module.exports = __webpack_public_path__ + "static/img/perform.ae9bbe4f.png";